import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UseMutationResult, UseMutationOptions } from '@tanstack/react-query';
import {
  updateProgramMedia,
  type UpdateProgramMediaParams,
  type UpdateProgramMediaResult
} from '../services/rpc';

/**
 * React Query mutation hook to update program media/URL information
 * Automatically refetches report card data after successful update
 */
export function useUpdateProgramMedia(
  options?: UseMutationOptions<
    UpdateProgramMediaResult,
    Error,
    UpdateProgramMediaParams
  >
): UseMutationResult<UpdateProgramMediaResult, Error, UpdateProgramMediaParams> {
  const queryClient = useQueryClient();

  return useMutation<UpdateProgramMediaResult, Error, UpdateProgramMediaParams>({
    mutationFn: updateProgramMedia,
    onSuccess: (_data, variables) => {
      // Invalidate report card query (used by QualityCheckCard)
      queryClient.invalidateQueries({
        queryKey: ['program-report-card']
      });

      // Invalidate URL validation (URLs changed, need re-validation)
      queryClient.invalidateQueries({
        queryKey: ['url-validation', variables.program_id]
      });

      // Invalidate activity logs
      queryClient.invalidateQueries({
        queryKey: ['activity-log', variables.program_id]
      });
    },
    ...options
  });
}

export default useUpdateProgramMedia;
